import { ActionType, getType } from 'typesafe-actions';
import * as actions from '../actions';
import * as auditActions from './actions';
import { deleteAllPagesData, clearUserProfileInfo } from 'src/containers/UserProfile/actions';

type HistoryAction = ActionType<typeof actions>;
type AuditActions = ActionType<typeof auditActions.syncActions>;
type AuditControlActions = ActionType<typeof auditActions.controlActions>;
type GlobalActions = ActionType<typeof deleteAllPagesData> | ActionType<typeof clearUserProfileInfo>;

type Action = HistoryAction | AuditActions | AuditControlActions | GlobalActions;

export interface AuditState {
  logs: AuditActions[];
}

const initialState: AuditState = {
  logs: [],
};

export const auditReducer = (state: AuditState = initialState, action: Action): AuditState => {
  switch (action.type) {
    case getType(auditActions.syncActions.onPageCreated):
    case getType(auditActions.syncActions.onPageUpdated):
    case getType(auditActions.syncActions.onPageDeleted): {
      state.logs.push(action);
      break;
    }
    case getType(actions.deleteAllPages): {
      break;
    }
    case getType(auditActions.controlActions.markLogAsSynced): {
      const existingLog = state.logs.find(log => log.meta.id === action.payload);

      if (existingLog) {
        existingLog.meta.needSync = false;
        existingLog.meta.syncedAt = new Date();
      }
    }
    case getType(clearUserProfileInfo):
    case getType(deleteAllPagesData.success): {
      state.logs = [];
    }
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/AuditLog/reducer.ts